import React from "react";
import { View, TouchableOpacity, StyleSheet, ActivityIndicator } from "react-native";
import { Ionicons } from "@expo/vector-icons";

/**
 * User location button for the map - centers map on user location when pressed.
 * Used by MapScreen (native) and MapScreen.web.
 * When embedded=true, the outer container is omitted so the parent can position with Animated.View for instant tracking.
 */
export default function UserLocationButton({ onPress, hasLocation, bottom, embedded, loading }) {
  const content = (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={0.7}
      disabled={loading}
      hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      style={styles.pressable}
      accessibilityRole="button"
      accessibilityLabel="Center map on your location"
    >
      <View
        style={[
          styles.button,
          {
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.25,
            shadowRadius: 3.84,
            elevation: 8,
          },
        ]}
      >
        {loading ? (
          <ActivityIndicator size="small" color="#4e2916" />
        ) : (
          <Ionicons
            name={hasLocation ? "locate" : "locate-outline"}
            size={24}
            color={hasLocation ? "#4e2916" : "black"}
          />
        )}
        {hasLocation && !loading ? <View style={styles.locationIndicator} /> : null}
      </View>
    </TouchableOpacity>
  );

  if (embedded) {
    return content;
  }
  return <View style={[styles.container, { bottom }]}>{content}</View>;
}

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    right: 0,
    paddingHorizontal: 16,
    paddingVertical: 4,
    zIndex: 0,
    elevation: 0,
  },
  pressable: {
    alignSelf: "flex-start",
  },
  button: {
    position: "relative",
    width: 44,
    height: 44,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: 22,
    padding: 0,
    borderWidth: 2,
    borderColor: "#d3d3d3",
  },
  locationIndicator: {
    position: "absolute",
    top: 3,
    right: 3,
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: "#4CAF50",
    borderWidth: 2,
    borderColor: "#FFFFFF",
  },
});
